module.exports = __webpack_public_path__ + "img/delete-self.f53fa5fa.svg";